import { render, staticRenderFns } from "./LogsIntegracao.vue?vue&type=template&id=6b924e97&scoped=true"
import script from "./LogsIntegracao.vue?vue&type=script&lang=js"
export * from "./LogsIntegracao.vue?vue&type=script&lang=js"
import style0 from "./LogsIntegracao.vue?vue&type=style&index=0&id=6b924e97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b924e97",
  null
  
)

export default component.exports